<template>
  <div id="weather-typhoon">
    <div>
      <vs-row v-if="localTyphoonList.length !== 0" vs-type="flex" class="mt-4 mb-2" vs-justify="flex-end">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="12"
        >
          <vs-switch v-model="showTyphoon" :color="AISEA_COLOR.BLUE"/>
        </vs-col>
      </vs-row>
      <vs-row vs-type="flex" class="mt-4 mb-2">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="12"
        >
          <span v-if="localTyphoonList.length === 0" class="aisea-text-14-400-white">現在台風発生なし</span>
          <span v-else class="aisea-text-14-400-white">{{ requestTime }}更新</span>
          <vs-button v-if="localTyphoonList.length !== 0" id="update-typhoon-button-with-loading" @click="updateTyphoon"
                     class="ml-4 vs-con-loading__container" :color="AISEA_COLOR.BLUE"
                     type="filled" icon-pack="feather" icon="icon-refresh-cw" size="small" :disabled="!showTyphoon">更新
          </vs-button>
        </vs-col>
      </vs-row>
    </div>
    <VuePerfectScrollbar
      class="scroll-area"
      :settings="scrollSettings"
    >
      <vs-row v-for="(typhoon, index) in localTyphoonList"
              :key="index" vs-type="flex" class="mt-4">
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="1"
        >
          <img :src="typhoonIcon" class="default-cursor">
        </vs-col>
        <vs-col
          vs-order="1"
          vs-type="flex"
          vs-justify="start"
          vs-align="center"
          vs-w="7"
        >
          <span class="aisea-text-14-400-white" @click="jumpToTyphoon(index)">{{ typhoon.name }}</span>
        </vs-col>
        <vs-col
          vs-order="2"
          vs-type="flex"
          vs-justify="flex-end"
          vs-align="center"
          vs-w="4"
        >
        </vs-col>
      </vs-row>
    </VuePerfectScrollbar>
  </div>
</template>

<script>
import {createNamespacedHelpers} from "vuex";
import VuePerfectScrollbar from "vue-perfect-scrollbar";

// Store
const {
  mapActions: mapActionsOfLiveMap,
  mapGetters: mapGettersOfLiveMap,
  mapMutations: mapMutationsOfLiveMap,
  mapState: mapStateOfLiveMap
} = createNamespacedHelpers("liveMap");

// Mixins
import {TyphoonMixin, ColorMixin} from "@/mixins";

export default {
  mixins: [TyphoonMixin, ColorMixin],
  components: {
    VuePerfectScrollbar,
  },
  data() {
    return {
      selectedElements: "oceanWind",
      typhoonIcon: require("@/assets/images/weather/typhoon.svg"),
      scrollSettings: {
        maxScrollbarLength: 20,
        wheelSpeed: 0.6
      },
      requestTime: null,
      localTyphoonList: [],
      showTyphoon: true
    };
  },
  computed: {
    ...mapStateOfLiveMap({typhoonInfoList: state => state.typhoonInfoList}),
    ...mapGettersOfLiveMap(["getMetoceanInitialDatetime", "getCurrentMetoceanSourceLayerId"]),
  },
  methods: {
    ...mapMutationsOfLiveMap(["SET_JUMP_TO_MAP", "SET_TYPHOON_LAYER_VISIBILITY"]),
    ...mapActionsOfLiveMap(["getTyphoonInfo"]),
    jumpToTyphoon(id) {
      let typhoonInfo = this.localTyphoonList.find(v => v.id === id)
      let options = {
        center: typhoonInfo.coordinate,
        zoom: 5,
      }
      this.SET_JUMP_TO_MAP(options)
    },
    async updateTyphoon() {
      this.$vs.loading({
        background: this.AISEA_COLOR.BLUE,
        color: this.AISEA_COLOR.WHITE,
        container: "#update-typhoon-button-with-loading",
        scale: 0.45
      })
      await this.getTyphoonInfo()
      this.$vs.loading.close("#update-typhoon-button-with-loading > .con-vs-loading")
    }
  },
  watch: {
    showTyphoon(isShow) {
      this.SET_TYPHOON_LAYER_VISIBILITY(isShow)
    },
    typhoonInfoList(newTyphoonInfoList) {
      if (newTyphoonInfoList === null) return;
      this.localTyphoonList.splice(0, this.localTyphoonList.length)
      if (newTyphoonInfoList.length === 0) {
        this.localTyphoonList = []
        return
      }
      newTyphoonInfoList.forEach((typhoon, i) => {
        this.requestTime = typhoon.requestTime
        this.localTyphoonList.push({
          id: i,
          name: this.getTyphoonName(typhoon.number, typhoon.nowcastData[0].props.class),
          coordinate: this.getCoordinateWithDegree(typhoon.nowcastData[0].props.centerPart.centerCoordinate)
        });
      });
    }
  }
};
</script>

<style lang="scss">
#weather-typhoon {
  default-cursor {
    cursor: default;
  }

  .scroll-area {
    max-height: 20vh;

    &:not(.ps) {
      overflow-y: auto;
    }
  }

}

</style>
